import { gql } from 'graphql.macro';

export const getDenthubSettingsTemplate = gql`
    query denthubSettings {
        denthubSettings {
            _id
            labAppBanner {
                title
                message
                severity
                isEnabled
            }
            clinicAppBanner {
                title
                message
                severity
                isEnabled
            }
            authAppBanner {
                title
                message
                severity
                isEnabled
            }
            activeDbMode
            activeDataSetSnapshotDate
            emailOtpEnabled
        }
    }
`;
